import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f2162a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-0 flex" }
const _hoisted_2 = { class: "flex-none tabs-separtor border-r-2" }
const _hoisted_3 = { class: "flex items-center -gap-x-4 px-8" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "h-full px-4 flex justify-start items-start" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-secondary" }
const _hoisted_10 = { key: 1 }

import { ref } from 'vue';
import { PageWithChildrenDto } from 'stores/modules/page';
import tmpl from 'src/utils/tmpl';
import AppLink from './AppLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SvProductMenu',
  props: {
    pages: {}
  },
  setup(__props: any) {



const tab = ref<number>(0);

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        vertical: "",
        "active-class": "text-highlight"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: page.id
            }, [
              (page.children?.length)
                ? (_openBlock(), _createBlock(_component_q_tab, {
                    key: 0,
                    class: "flex justify-start text-sm",
                    name: i,
                    ripple: false,
                    "no-caps": ""
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (page.icon)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "w-6 h-6",
                              src: page.icon,
                              alt: "icon"
                            }, null, 8, _hoisted_4))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, _toDisplayString(page.title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_tab_panels, {
        class: "h-full",
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
        animated: "",
        swipeable: "",
        vertical: "",
        "transition-prev": "jump-up",
        "transition-next": "jump-up"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: page.id
            }, [
              (page.children?.length)
                ? (_openBlock(), _createBlock(_component_q_tab_panel, {
                    key: 0,
                    class: "overflow-y-hidden p-0 pt-3 text-sm -mb-8",
                    name: i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.children, (child) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: child.id,
                            class: "mr-10 mb-10"
                          }, [
                            _createElementVNode("div", _hoisted_7, [
                              (child.url)
                                ? (_openBlock(), _createBlock(AppLink, {
                                    key: 0,
                                    class: "hover:text-highlight",
                                    to: _unref(tmpl)(child.url, child)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(child.title), 1))
                            ]),
                            _createElementVNode("ul", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandson) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: grandson.id,
                                  class: "pb-3 flex justify-start items-center"
                                }, [
                                  (grandson.url)
                                    ? (_openBlock(), _createBlock(AppLink, {
                                        key: 0,
                                        class: "hover:text-highlight",
                                        to: _unref(tmpl)(grandson.url, grandson)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(grandson.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(grandson.title), 1)),
                                  (grandson.keywords.label)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        class: _normalizeClass(`ml-2 px-1.5 py-0.5 text-xs tag-${grandson.keywords.type}`)
                                      }, _toDisplayString(grandson.keywords.label), 3))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["name"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})